var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-changes"},[_c('div',{staticClass:"no-changes__container"},[_c('div',{staticClass:"no-changes__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"no-changes__description"},[_c('span',{staticClass:"no-changes__description-text"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }